module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"moscow":"Москва","chelyabinsk":"Челябинск","nizhny tagil":"Нижний Тагил","tomsk":"Томск","saint petersburg":"Санкт-Петербург"},"en":{"moscow":"Moscow","chelyabinsk":"Chelyabinsk","nizhny tagil":"Nizhny Tagil","tomsk":"Tomsk","saint petersburg":"Saint Petersburg"}}')
  delete Component.options._Ctor
}
